// extracted by mini-css-extract-plugin
module.exports = {"shippingInfoContainer":"_b562f698","shipsFrom":"_676fd704","hoverable":"_a3d4a0cf","tooltipWrapper":"_910e9aa5","shippingModalLink":"_36d0e01a"};